export default "__VITE_ASSET__BErrd_KT__"